// extracted by mini-css-extract-plugin
export default {"badgeBody":"schiber_badgeBody__ESyq_","mirrored":"schiber_mirrored__xl_gT"};